import { ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { Reveal, SectionHeading } from "@/components/Reveal";

const STEPS = [
  { cmd: "step_01", text: "Install Phantom or Solflare wallet" },
  { cmd: "step_02", text: "Load up on SOL from any exchange" },
  { cmd: "step_03", text: "Paste the $PEPEBUTT contract — revealed at launch" },
  { cmd: "step_04", text: "Swap. Hold. Clap responsibly." },
];

export default function HowToBuy() {
  const copyCa = () =>
    toast("CONTRACT NOT LIVE YET", {
      description: "CA drops at launch — links revealed on X and Telegram first.",
    });

  return (
    <section id="how-to-buy" data-testid="how-to-buy-section" className="relative py-28 sm:py-36">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading index="04" eyebrow="HOW TO BUY" title="COP THE CHEEKS" testId="how-to-buy-heading" />

        <Reveal delay={0.1} className="mt-14 max-w-3xl">
          <div className="border border-neon/40 bg-surface shadow-[inset_0_0_40px_rgba(57,255,20,0.04)]">
            <div className="flex items-center gap-2 border-b border-line px-5 py-3">
              <span className="h-2.5 w-2.5 rounded-full bg-blood/80" />
              <span className="h-2.5 w-2.5 rounded-full bg-punk/70" />
              <span className="h-2.5 w-2.5 rounded-full bg-neon/80" />
              <span className="ml-3 font-mono text-[11px] tracking-[0.2em] text-[#6b7f6b] uppercase">
                pepebutt@solana: ~/buy
              </span>
            </div>
            <div className="px-5 py-6 font-vt text-lg leading-loose sm:px-8 sm:text-xl">
              <p className="text-[#6b7f6b]">$ pepebutt --buy --chain solana</p>
              {STEPS.map((s, i) => (
                <Reveal key={s.cmd} delay={0.15 + i * 0.12}>
                  <p data-testid={`buy-step-${i + 1}`} className="text-[#9fb39f]">
                    <span className="text-neon">{">"} {s.cmd}:</span> {s.text}
                  </p>
                </Reveal>
              ))}
              <p className="animate-flicker text-neon">
                {">"} status: CHEEKS.EXE RUNNING
                <span className="animate-blink ml-1">█</span>
              </p>
            </div>
          </div>

          <div className="mt-8 flex flex-wrap gap-4">
            <a
              data-testid="get-pumpfun-link"
              href="https://pump.fun"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 border border-neon bg-neon px-6 py-3 font-mono text-xs font-bold tracking-[0.15em] text-nox uppercase transition-colors duration-200 hover:bg-transparent hover:text-neon"
            >
              Get Pump.fun <ExternalLink size={14} />
            </a>
            <button
              data-testid="how-to-buy-copy-ca-button"
              onClick={copyCa}
              className="border border-line px-6 py-3 font-mono text-xs tracking-[0.15em] text-[#9fb39f] uppercase transition-colors duration-200 hover:border-neon hover:text-neon"
            >
              Copy CA (TBA)
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
